
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import DateService from '@/apps/shared/utils/formatDate';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import XSummary from '@/apps/shared/components/summary.vue';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper'; 
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default Vue.extend({
        name: 'HogarPremiumSummary',
        components: {
            XSummary,
        },
        data() {
            return {
                productDetails: {
                    product: "/hogar-premium",
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    capital: null,
                    undiscountedPrice: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/hogar-premium' },
                        { text: 'Resumen', path: '/hogar-premium/resumen' },
                    ],
                    icon: {
                        src: '/Logos/hogarPremium.svg',
                        alt: 'HogarPremium',
                        title: 'HogarPremium'
                    },
                } as SummaryDetails,
                GUiD: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                const actualStep = 'summary';

                const planData = JSON.parse(sessionStorage.getItem("PlanSelected"));
                const clientData = JSON.parse(sessionStorage.getItem("stepOneData"));
                const tabTwoData = JSON.parse(sessionStorage.getItem("TabTwoData"));
                const securitySystem = JSON.parse(sessionStorage.getItem("SecuritySystem"));

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = clientData.lastName;
                request.firstName = clientData.firstName;
                request.phone = clientData.areaCode + clientData.telephone;
                request.mail = clientData.email;
                request.quotePlan = planData.planDescription;

                const securitySystemString = Array.isArray(securitySystem) && securitySystem.length > 0
                    ? securitySystem.join(', ')
                    : "No";

                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Localidad: " + tabTwoData.selectedLocality.text
                    + " - Tipo: " + tabTwoData.articleCode.description.trim()
                    + " - M2: " + Number(tabTwoData.surfaceHouse).toLocaleString('es-AR')
                    + " - Valor: $" + Number(planData.plans[0].capital).toLocaleString('es-AR')
                    + " - Medidas Seguridad: " + securitySystemString;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            setSessionParams() {
                const rawClient = JSON.parse(sessionStorage.getItem("stepOneData")!);
                const rawHogar = JSON.parse(sessionStorage.getItem("TabTwoData")!);
                const rawSecurity = JSON.parse(sessionStorage.getItem("SecuritySystem")!);
                const rawPlan = JSON.parse(sessionStorage.getItem("PlanSelected")!);
                const leadId = JSON.parse(sessionStorage.getItem("LeadId")!);
                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");

                const payload = {
                    productId: 927,
                    pricingId: rawPlan.pricingId,
                    leadId: leadId,

                    contratante: {
                        firstName: rawClient.firstName,
                        lastName: rawClient.lastName,
                        documentNumber: rawClient.documentNumber,
                        areaCode: rawClient.areaCode,
                        telephone: rawClient.telephone,
                        email: rawClient.email
                    },

                    plan: {
                        planDescription: rawPlan.planDescription,
                        premioMensual: Number(rawPlan.premioMensual),
                        premioMensualFormatted: rawPlan.premioMensualFormatted,
                        pricingId: rawPlan.pricingId
                    },

                    hogar: {
                        articleCode: {
                            description: rawHogar.articleCode.description
                        },
                        selectedLocality: {
                            name: rawHogar.selectedLocality.name,
                            zipCode: rawHogar.selectedLocality.zipCode
                        }
                    },

                    buildingCapitalSelected: {
                        amount: rawPlan.plans[0].capital
                    },

                    SecuritySystem: rawSecurity,
                    rutaAlternativa: rutaAlternativa,
                    referente: this.referente,
                };
                const jsonString = JSON.stringify(payload);


                return ParamCotizService.setParamCotiz(jsonString)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },

            getCUPE: function () {
                var email = "";
                var productId = 927;
                NF.UI.Page.block();
                var timeStart = new Date().getTime();
                CUPEService.GetCUPEUrl(productId, email, this.GUiD).then(response => {
                    if (response != null) {
                        this.productDetails.cupeUrl = response.preferenceMessage;
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.productDetails.email,
                            'product': 'hogarPremium',
                            'event': 'cotizador-hogar-premium-datos-validar',
                            'referente': this.referente
                        });
                        var endTime = new Date().getTime();
                        var secondCharge = Math.round((endTime - timeStart) / 1000);
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.productDetails.email,
                            'product': 'hogarPremium',
                            'event': 'cotizador-hogar-premium-resumen',
                            'carga': secondCharge,
                            'referente': this.referente
                        });
                        NF.UI.Page.unblock();
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.productDetails.email,
                            'product': 'hogarPremium',
                            'event': 'errorUsuario',
                            'paso': 'cotizador-hogar-premium-datos-validar',
                            'referente': this.referente
                        });
                    }
                }).catch((error) => {
                    console.error('Error al obtener la URL:', error);
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },

            async fetchSessionPayload() {
                const guid = sessionStorage.getItem('ParamId');
                if (guid)
                    await ParamCotizService.getParamCotiz(guid);
            },

            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true")

                const today = new Date();
                const nextYearDate = new Date(today);
                nextYearDate.setFullYear(today.getFullYear() + 1);

                this.productDetails.effectDate = DateService.formatDate(today);
                this.productDetails.expirationDate = DateService.formatDate(nextYearDate);

                const personData = sessionStorage.getItem("stepOneData");
                const planDataSelected = sessionStorage.getItem("PlanSelected");

                if (personData != null) {
                    const person = JSON.parse(personData!);
                    this.productDetails.name = person.firstName + ' ' + person.lastName;
                    this.productDetails.email = person.email;
                    this.productDetails.telephone = person.areaCode + '-' + person.telephone;
                }

                if (planDataSelected != null) {
                    const dataPlan = JSON.parse(planDataSelected!);
                    this.productDetails.capital = dataPlan.plans[0].capital.toLocaleString('de-DE', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });;
                    this.productDetails.planDescription = dataPlan.planDescription;
                    this.productDetails.firstPaymentFee = dataPlan.premioMensual.toLocaleString('de-DE', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                    this.productDetails.undiscountedPrice = dataPlan.premioMensualSinDescuentoFormatted.replace('$', '');
                    this.productDetails.cover = dataPlan.plans.filter(o => o.value == "SI");
                    NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                    await DiscountRangeService.getFamilyCombinedDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.productDetails.rate = response[0].discountMaxValue;
                        }
                    }).finally(() => {
                        NF.UI.Page.unblock();
                    });
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                await this.fetchSessionPayload();

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData(),
                    this.setSessionParams(),
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getCUPE();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
